import { createElement } from 'react';

import { Components, Theme } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

import { Icon } from '@/components/ui/Icon';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    popupIcon: createElement(Icon, {
      size: 'large',
      name: 'keyboard_arrow_down',
      color: scssVariables.ColorBlack60,
    }),
    classes: {
      listbox: 'MuiCustomScrollbarHelper', // add custom scrollbar helper class to the listbox
    },
    slotProps: {
      clearIndicator: {
        size: 'small',
      },
    },
  },
  styleOverrides: {
    root: {
      '.MuiAutocomplete-popupIndicator': {
        paddingRight: 0,
        marginRight: '-5px', // align with regular Select icon
        '&:hover': { backgroundColor: 'transparent' },
        '&[disabled]': {
          opacity: '0.6',
        },

        '@media screen and (prefers-reduced-motion: no-preference) ': {
          transition: 'transform 150ms ease-out',
        },
      },
    },
    paper: {
      padding: '4px 6px 4px 14px',

      '.MuiAutocomplete-noOptions': {
        paddingLeft: '10px', // hardcoded to align with the option spacing, which have a different DOM nesting
        paddingTop: scssVariables.SpacingUnit2,
        minHeight: '50px',
      },
    },
    listbox: {
      paddingRight: '2px',
      paddingLeft: '2px',
      maxHeight: 'max(40vh, min(80vh, 350px))',

      '.MuiAutocomplete-option': {
        padding: scssVariables.SpacingUnit1,
        borderRadius: scssVariables.BorderRadiusMedium,
        font: scssVariables.FontBodyRegular,

        '&:not(:first-child)': {
          marginTop: '4px',
        },

        '&[aria-selected="true"], &[aria-selected="true"].Mui-focused, .Mui-focused':
          {
            backgroundColor: scssVariables.ColorFog40,

            '&:hover': {
              backgroundColor: scssVariables.ColorFog60,
            },
            '&.Mui-focused:not(:hover)': {
              backgroundColor: scssVariables.ColorFog40,
              outline: `2px solid ${scssVariables.ColorFog80}`,
            },
          },

        '&:hover:not(.Mui-selected), &.Mui-focused:not(.Mui-selected)': {
          backgroundColor: scssVariables.ColorFog20,
        },
      },
    },
  },
};
